// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumOrganizationType } from '../../../../../com/MetaPattern/APP/MDA/User/EnumOrganizationType';
import { EnumCertifyStatus } from '../../../../../com/MetaPattern/APP/MDA/User/EnumCertifyStatus';
import { Tenancy } from './Tenancy';
import { Person } from './Person';
/**
 * 机构 实体类
 * 机构组织，包括各种类型组织的具体信息
 */
export class Organization extends BaseEntity {
  /** 名称 : 机构的完整名称，与营业执照一致 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 机构类型 : 机构类型 */
  private _organizationType: EnumOrganizationType;

  /** 设置：机构类型 */
  public get organizationType() {
    return this._organizationType;
  }

  /** 获取：机构类型 */
  public set organizationType(value: EnumOrganizationType) {
    this._organizationType = value;
  }

  /** 营业执照号码 : 营业势照注册号上的注册号或统一社会信用代码 */
  private _businessLicenseNo: string;

  /** 设置：营业执照号码 */
  public get businessLicenseNo() {
    return this._businessLicenseNo;
  }

  /** 获取：营业执照号码 */
  public set businessLicenseNo(value: string) {
    this._businessLicenseNo = value;
  }

  /** 营业执照证件 : 营业执照证件照片，不超过10M */
  private _businessLicenseFile: string;

  /** 设置：营业执照证件 */
  public get businessLicenseFile() {
    return this._businessLicenseFile;
  }

  /** 获取：营业执照证件 */
  public set businessLicenseFile(value: string) {
    this._businessLicenseFile = value;
  }

  /** 认证状态 : 机构的实名认证状态，仅对机构有效，对团队无效 */
  private _certifyStatus: EnumCertifyStatus;

  /** 设置：认证状态 */
  public get certifyStatus() {
    return this._certifyStatus;
  }

  /** 获取：认证状态 */
  public set certifyStatus(value: EnumCertifyStatus) {
    this._certifyStatus = value;
  }

  /** 银行名称 : 银行名称 */
  private _bankName: string;

  /** 设置：银行名称 */
  public get bankName() {
    return this._bankName;
  }

  /** 获取：银行名称 */
  public set bankName(value: string) {
    this._bankName = value;
  }

  /** 银行账号 : 银行账号 */
  private _bankAccountNo: string;

  /** 设置：银行账号 */
  public get bankAccountNo() {
    return this._bankAccountNo;
  }

  /** 获取：银行账号 */
  public set bankAccountNo(value: string) {
    this._bankAccountNo = value;
  }

  /** 上级机构 的ID */
  private _parent_ID: string;

  /** 获取：上级机构 的ID */
  public get parent_ID() {
    return this._parent_ID;
  }

  /** 设置：上级机构 的ID */
  public set parent_ID(value: string) {
    this._parent_ID = value;
  }

  /** 上级机构  */
  private _parent: Organization;

  /** 获取：上级机构  */
  public get parent() {
    return this._parent;
  }

  /** 设置：上级机构  */
  public set parent(value: Organization) {
    this._parent = value;
    if (value !== null) {
      this.parent_ID = value.id;
    } else {
      this.parent_ID = '';
    }
  }

  /** 租户 */
  private _tenancies: Array<Tenancy>;

  /** 获取：租户 */
  public get tenancies() {
    return this._tenancies;
  }

  /** 设置：租户 */
  public set tenancies(value: Array<Tenancy>) {
    this._tenancies = value;
  }

  /** 下级机构 */
  private _children: Array<Organization>;

  /** 获取：下级机构 */
  public get children() {
    return this._children;
  }

  /** 设置：下级机构 */
  public set children(value: Array<Organization>) {
    this._children = value;
  }

  /** 法人 的ID */
  private _corporation_ID: string;

  /** 获取：法人 的ID */
  public get corporation_ID() {
    return this._corporation_ID;
  }

  /** 设置：法人 的ID */
  public set corporation_ID(value: string) {
    this._corporation_ID = value;
  }

  /** 法人  */
  private _corporation: Person;

  /** 获取：法人  */
  public get corporation() {
    return this._corporation;
  }

  /** 设置：法人  */
  public set corporation(value: Person) {
    this._corporation = value;
    if (value !== null) {
      this.corporation_ID = value.id;
    } else {
      this.corporation_ID = '';
    }
  }

  constructor() {
    super();
    this._name = '';
    this._organizationType = EnumOrganizationType.Team;
    this._businessLicenseNo = '';
    this._businessLicenseFile = '';
    this._certifyStatus = EnumCertifyStatus.None;
    this._bankName = '';
    this._bankAccountNo = '';
    this._parent_ID = '';
    this._parent = null;
    this._tenancies = new Array<Tenancy>();
    this._children = new Array<Organization>();
    this._corporation_ID = '';
    this._corporation = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Organization, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.organizationType = element.organizationType;
      this.businessLicenseNo = element.businessLicenseNo;
      this.businessLicenseFile = element.businessLicenseFile;
      this.certifyStatus = element.certifyStatus;
      this.bankName = element.bankName;
      this.bankAccountNo = element.bankAccountNo;
      this.parent_ID = element.parent_ID;
      if (hasReference && element.parent !== null) {
        this.parent = element.parent;
      }
      this.corporation_ID = element.corporation_ID;
      if (hasReference && element.corporation !== null) {
        this.corporation = element.corporation;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.organizationType = json.OrganizationType as EnumOrganizationType;
    this.businessLicenseNo = json.BusinessLicenseNo;
    this.businessLicenseFile = json.BusinessLicenseFile;
    this.certifyStatus = json.CertifyStatus as EnumCertifyStatus;
    this.bankName = json.BankName;
    this.bankAccountNo = json.BankAccountNo;
    this.parent_ID = json.Parent_ID;
    // if (json.Parent !== null) {
    //   this.parent = Organization.Create(json.Parent);
    // }
    if (json.Tenancies && json.Tenancies.length > 0) {
      json.Tenancies.forEach((element: any) => {
        const tenancy = Tenancy.Create(element);
        // tenancy.organization = this;
        this.tenancies.push(tenancy);
      });
    }
    if (json.Children && json.Children.length > 0) {
      json.Children.forEach((element: any) => {
        const organization = Organization.Create(element);
        // organization.parent = this;
        this.children.push(organization);
      });
    }
    this.corporation_ID = json.Corporation_ID;
    // if (json.Corporation !== null) {
    //   this.corporation = Person.Create(json.Corporation);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.OrganizationType = this.organizationType;
    json.BusinessLicenseNo = this.businessLicenseNo;
    json.BusinessLicenseFile = this.businessLicenseFile;
    json.CertifyStatus = this.certifyStatus;
    json.BankName = this.bankName;
    json.BankAccountNo = this.bankAccountNo;
    json.Parent_ID = this.parent_ID;
    if (this.tenancies && this.tenancies.length > 0) {
      json.Tenancies = [];
      this.tenancies.forEach((element) => {
        json.Tenancies.push(element.toJson());
      });
    }
    if (this.children && this.children.length > 0) {
      json.Children = [];
      this.children.forEach((element) => {
        json.Children.push(element.toJson());
      });
    }
    json.Corporation_ID = this.corporation_ID;
  }

  static Create(json: any): Organization {
    const organization = new Organization();
    organization.Deserialize(json);
    organization.json = json;
    return organization;
  }
}
